import { flowRight } from 'lodash';
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from '../../../common/components/runtime-context';

import {
  SECTION_CATEGORY,
  isLayoutProGallery,
  getAppConfig,
  getCategoryUrl,
  createPageUrl,
} from '@wix/communities-blog-client-common';

import { resolveCategorySlug } from '../../../common/services/slug';
import { getCategoryBySlug } from '../../../common/selectors/categories-selectors';
import { getIsCategoryLoaded } from '../../../common/store/is-loaded/is-loaded-selectors';
import { getIsCategoryLoading } from '../../../common/store/is-loading/is-loading-selectors';
import { getSortedPostsByCategoryId, getPostsByCategoryIdAndPage } from '../../../common/selectors/post-selectors';
import { isExcludePostContentSupported } from '../../../common/selectors/layout-selectors';
import { getCanSeeMoreButton, getIsCategoryHeaderEnabled } from '../../../common/selectors/app-settings-selectors';
import withAuth from '../../../common/hoc/with-auth';
import withLayoutProps from '../../../common/hoc/with-layout-props';
import withPaginationSettings from '../../hoc/with-pagination-settings';
import withPermissions from '../../../common/hoc/with-permissions';
import withTranslate from '../../../common/hoc/with-translate';
import withComponents from '../../../common/components/components-provider/with-components';
// import AccountSuspended from '../../components/account-suspended';
import AnimatedLoader from '../../../common/components/animated-loader';
import AppLoaded from '../../../common/components/app-loaded';
import CategoryHeader from '../../components/category-header';
import NoPosts from '../no-posts';
import Page from '../../../common/components/page';
import Pagination from '../../../common/containers/pagination';
import PostList from '../../components/post-list';
import { EmptyLayout } from '../../../common/components/layout';
import { handleNavigation } from '../../../common/services/navigation';

import { getIsMobile, isSite } from '../../../common/store/basic-params/basic-params-selectors';
import { isCreatePostButtonVisible } from '../../../common/selectors/blog-menu-button-selectors';
import { getSectionUrl } from '../../../common/store/topology/topology-selectors';

const Layout = EmptyLayout;

export class CategoryPage extends Component {
  state = {
    isAnimated: !this.props.allPosts.length,
  };

  // constructor(props) {
  //   super(props);
  //   // this.handleLikeClick = this.handleLikeClick.bind(this);
  //   this.state = {
  //     isAnimated: !props.allPosts.length,
  //   };
  // }

  // componentDidMount() {
  //   const { category, page, isAppLoaded } = this.props;

  //   if (isAppLoaded && page === 1) {
  //     this.fetchPosts(category._id);
  //   }
  // }

  componentWillUnmount() {
    const { category } = this.props;

    this.props.setIsLoaded('category', category._id, false);
  }

  componentDidUpdate({ isAuthenticated, isBlocked, pageSize, excludeContent }) {
    const { category } = this.props;
    if (
      this.props.isAuthenticated !== isAuthenticated ||
      this.props.isBlocked !== isBlocked ||
      this.props.pageSize !== pageSize ||
      (excludeContent && !this.props.excludeContent)
    ) {
      this.fetchPosts(category._id);
    }
  }

  fetchPosts(categoryId, page = this.props.page) {
    if (this.props.isBlocked) {
      return;
    }

    this.props.fetchCategoryPosts({ categoryId, page, excludeContent: this.props.excludeContent });
  }

  loadMore = (page) => this.fetchPosts(this.props.category._id, page);

  renderPosts() {
    const {
      // isBlocked,
      currentPagePosts,
      allPosts,
      entityCount,
      category,
      isCategoryLoading,
      isCategoryLoaded,
      showCreatePostAction,
      page,
      layoutType,
      showPagination,
      PostListProGallery,
      canSeeMoreButton,
    } = this.props;
    const hasPosts = allPosts.length;

    // if (isBlocked) {
    //   return <AccountSuspended />;
    // }

    if (!hasPosts && isCategoryLoaded) {
      return <NoPosts category={category} />;
    }

    if (isLayoutProGallery(layoutType)) {
      return (
        <PostListProGallery
          pageStart={page + 1}
          entityCount={entityCount}
          loadMore={showPagination ? undefined : this.loadMore}
          allPosts={showPagination ? currentPagePosts : allPosts}
          currentPagePosts={currentPagePosts}
          isLoading={isCategoryLoading}
          showCreatePostAction={showCreatePostAction}
          canSeeMoreButton={canSeeMoreButton}
          section={SECTION_CATEGORY}
        />
      );
    }

    return (
      <PostList
        pageStart={page + 1}
        layoutType={layoutType}
        entityCount={entityCount}
        loadMore={showPagination ? undefined : this.loadMore}
        allPosts={showPagination ? currentPagePosts : allPosts}
        currentPagePosts={currentPagePosts}
        isLoading={isCategoryLoading}
        category={category}
        isLoaded={isCategoryLoaded}
        showCreatePostAction={showCreatePostAction}
      />
    );
  }

  createPageUrl = (page) => createPageUrl(page, this.props.categoryUrl);

  renderPagination() {
    const { entityCount, pageSize, page, isSite, categoryPath, showPagination } = this.props;
    return (
      <div data-hook="category-pagination-container" style={{ display: showPagination ? 'block' : 'none' }}>
        <Pagination
          page={page}
          pageSize={pageSize}
          entityCount={entityCount}
          createPageUrl={this.createPageUrl}
          handleNavigation={handleNavigation(categoryPath, isSite)}
          showPagination={showPagination}
        />
      </div>
    );
  }

  render() {
    const { category, isCategoryLoading, isCategoryLoaded, allPosts, isCategoryHeaderEnabled } = this.props;

    const isLoading = isCategoryLoading && !isCategoryLoaded;

    return (
      <Page noSpacing>
        <Layout>
          {isCategoryHeaderEnabled && <CategoryHeader category={category} />}
          <AnimatedLoader isLoading={isLoading && !allPosts.length} isAnimated={this.state.isAnimated}>
            {this.renderPosts()}
          </AnimatedLoader>
          {!isLoading && this.renderPagination()}
          {isCategoryLoaded && <AppLoaded />}
        </Layout>
      </Page>
    );
  }
}

CategoryPage.propTypes = {
  categoryUrl: PropTypes.string.isRequired,
  categoryPath: PropTypes.string.isRequired,
  fetchCategoryPosts: PropTypes.func.isRequired,
  categoryId: PropTypes.string, // no id when creating new category in editor
  setIsLoaded: PropTypes.func.isRequired,
  allPosts: PropTypes.array,
  currentPagePosts: PropTypes.array,
  category: PropTypes.object,
  isAuthenticated: PropTypes.bool,
  isBlocked: PropTypes.bool,
  params: PropTypes.object,
  t: PropTypes.func,
  newPostId: PropTypes.string,
  isCategoryLoading: PropTypes.bool,
  isCategoryLoaded: PropTypes.bool,
  isSite: PropTypes.bool,
  showCreatePostAction: PropTypes.bool.isRequired,
  layoutType: PropTypes.number.isRequired,
  showHeader: PropTypes.bool,
  isCategoryHeaderEnabled: PropTypes.bool,
  excludeContent: PropTypes.bool,
  pageSize: PropTypes.number,
  entityCount: PropTypes.number,
  showPagination: PropTypes.bool,
  useCategoryMenuLabelForMetadataTitle: PropTypes.bool,
  isMoveCreatePostButtonEnabled: PropTypes.bool,
  PostListProGallery: PropTypes.elementType.isRequired,
  canSeeMoreButton: PropTypes.func.isRequired,
};

const mapRuntimeToProps = (state, ownProps, actions) => {
  const categorySlug = resolveCategorySlug(ownProps.params);
  const category = getCategoryBySlug(state, categorySlug) || {};
  const categoryId = category._id;
  const currentPagePosts = categoryId ? getPostsByCategoryIdAndPage(state, categoryId, ownProps.page) : [];
  const { categoryPath, useCategoryMenuLabelForMetadataTitle } = getAppConfig(state);
  const sectionUrl = getSectionUrl(state);
  const categoryUrl = getCategoryUrl(sectionUrl, categoryPath, categorySlug, true);

  const showCreatePostAction = getIsMobile(state) && isCreatePostButtonVisible(state, ownProps.canSee);

  return {
    categoryUrl,
    categoryPath: `/${categoryPath}/${categorySlug}`,
    category,
    allPosts: categoryId ? getSortedPostsByCategoryId(state, categoryId) : [],
    currentPagePosts,
    newPostId: state.newPostMessage,
    categoryId,
    isCategoryLoading: getIsCategoryLoading(state, categoryId),
    isCategoryLoaded: getIsCategoryLoaded(state, categoryId),
    isSite: isSite(state),
    showCreatePostAction,
    excludeContent: isExcludePostContentSupported(state),
    useCategoryMenuLabelForMetadataTitle,
    setIsLoaded: actions.setIsLoaded,
    fetchCategoryPosts: actions.fetchCategoryPostsPromisified,
    isCategoryHeaderEnabled: getIsCategoryHeaderEnabled(state),
    canSeeMoreButton: getCanSeeMoreButton(state, ownProps.canSee),
  };
};

export default flowRight(
  withComponents,
  withPermissions,
  withPaginationSettings(SECTION_CATEGORY),
  withLayoutProps(),
  withAuth,
  withTranslate,
  connect(mapRuntimeToProps),
)(CategoryPage);
